import { useEffect, useState } from 'react';

import type { BreakPoint } from '@/common/hooks/useBreakPoint';
import { useBreakPoint } from '@/common/hooks/useBreakPoint';
import { useActions, useAppState } from '@/overmind';
import type { SidebarState } from '@/overmind/namespaces/sidebar';

export function getNewSidebarState(
  isOpen: boolean,
  breakPoint: BreakPoint | undefined
): SidebarState {
  if (breakPoint == null || breakPoint === 'small') {
    return isOpen ? 'PopupOpen' : 'PopupClosed';
  } else {
    return isOpen ? 'Uncollapsed' : 'Collapsed';
  }
}

export function useSidebarState() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const currentState = useAppState().sidebar.current;
  const { setSidebarState } = useActions().sidebar;
  const currentBreakpoint = useBreakPoint();

  useEffect(() => {
    setSidebarState(getNewSidebarState(isOpen, currentBreakpoint));
  }, [isOpen, currentBreakpoint, setSidebarState]);

  const toggleSidebar = (open = !isOpen) => {
    setIsOpen(open);
  };

  return [currentState, toggleSidebar] as const;
}
